<script>
  import store from 'public/store'
  import CallDialog from './call-dialog'
  import phoneSrc from './phone.svg'

  export default {
    name: 'kye-field-call',
    props: {
      value: [String, Number],
      auth: {
        type: String
      }
    },
    components: {
      CallDialog
    },
    computed: {
      model () {
        return this.$parent.form.model
      },
      pathArr () {
        return this.$parent.prop ? this.$parent.prop.split('.') : []
      },
      pathLen () {
        return this.$parent.prop ? this.$parent.prop.split('.').length - 1 : 0
      },
      maskFiled () {
        let mask = null
        let virtual = null
        let maskSec = null
        if (this.model) {
          let tempModel = this.model
          this.pathArr.forEach((t, i) => {
            // 默认取最后一个字段 field.field.field
            if (i === this.pathLen) {
              // 监控字段
              if (tempModel[t + 'Mask']) {
                mask = tempModel[t + 'Mask']
              }
              // 虚拟号
              if (tempModel[t + 'Virtual']) {
                virtual = tempModel[t + 'Virtual']
              }
              // 敏感字段
              if (tempModel[t + 'MaskSec']) {
                maskSec = tempModel[t + 'MaskSec']
              }
            }
            tempModel = tempModel[t]
          })
        }
        return { mask, virtual, maskSec }
      }
    },
    methods: {
      handleClick (value) {
        const { mask, virtual, maskSec } = this.maskFiled
        this.$refs.callDialog.init({ callNumber: value, calledNumberEncrypt: mask || virtual || maskSec || '' })
        this.$refs.callDialog.show = true
      },
      save () {
        this.$emit('save')
      }
    },
    render (h) {
      const appendToBody = this.$attrs.appendToBody || this.$attrs['append-to-body']
      const showMeetingBtn = this.$attrs.showMeetingBtn || this.$attrs['show-meeting-btn']
      const extParams = this.$attrs.extParams || this.$attrs['ext-params']
      const customContent = this.$slots && this.$slots.customContent && this.$slots.customContent[0]
      let title = this.$slots && this.$slots.default && this.$slots.default[0] && this.$slots.default[0].text
      let show = false
      if (this.auth) {
        show = store.getters.permission.menus.includes(this.auth) ? this.value : false
      } else {
        show = this.value
      }
      title = this.value || title || ''
      if (title && typeof title === 'string') {
        title = title.trim()
      }
      return (
        <div class="kye-field-call">
          <span class={`kye-field-content ${show ? 'kye-field-call__right' : ''}`} title={ title }>
            <label>{ this.value !== undefined ? this.value : this.$slots.default }</label>
          </span>
          {
            show
              ? (
                  <div>
                    <div class="kye-field-call__phone" style={this.valaue || this.$slots.default} onClick={() => this.handleClick(title)}>
                      <img src={phoneSrc}/>
                    </div>
                    <call-dialog ref="callDialog" appendToBody={appendToBody} showMeetingBtn={showMeetingBtn} extParams={extParams} onSave={() => this.save()}>
                      customContent ? (<template slot="customContent">
                          {customContent}
                      </template>) : null
                    </call-dialog>
                  </div>
                )
              : null
          }
        </div>
      )
    }
  }
</script>

<style lang="scss">
  .kye-field-call {
    display: flex;
    justify-content: space-between;
    width: 100%;
    &__right {
      border-right: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      flex: 1;
    }
    &__phone {
      width: 20px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 4px;
      color: var(--g-color-primary);
      cursor: pointer;
      border: #d2d2d6 1px solid;
      height: 29px;
      border-left: 0;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-field-call/index.vue